// CSS Import
import '@/css/app.pcss';
import components from './_components';
import vendors from './_vendors';
// Add JS Loaded class to the body
document.documentElement.classList.add('js-loaded');

// App main
const main = async () => {
  await components();
  await vendors();
};

// Execute async function
main()
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  .then(() => {})
  .catch((e) => console.error(e));
